import { ParagraphPlugin } from 'platejs/react'

import { ParagraphElement } from './ParagraphElement'

const RichTextFieldParagraphPlugin: typeof ParagraphPlugin =
  ParagraphPlugin.withComponent(ParagraphElement)

export { ParagraphElement, RichTextFieldParagraphPlugin }
